import { url as baseUrl } from 'src/services/api/url';


const PATH = '/api/users/me/settings';
export const url = new URL(PATH, baseUrl);